import { defineComponent as _defineComponent } from 'vue'
import type { ClickoutUrl } from '@/helpers/clickout-helper';

import ProviderIcon from '@/components/picture/ProviderIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SportWatchNowButton',
  props: {
    clickoutUrl: null,
    packageId: null,
    lazy: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,ProviderIcon }
}

})